// Credit Name Max Input
function enforceMaxLength(input, maxLength) {
    input.addEventListener('input', function() {
        if (this.value.length > maxLength) {
            this.value = this.value.substring(0, maxLength);
        }
    });
    
    // Paste events
    input.addEventListener('paste', function(e) {
        setTimeout(() => {
            if (this.value.length > maxLength) {
                this.value = this.value.substring(0, maxLength);
            }
        }, 0);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const creditInput = document.getElementById('credit-name-1');
    enforceMaxLength(creditInput, 28);
});